import { FirstNames } from './FirstNames'
import { LastNames } from './LastNames'
import { Titles } from './Titles'
import { Countries } from './Countries'
import { Characters } from './Characters'

export const data = {
  firstnames: FirstNames,
  lastnames: LastNames,
  titles: Titles,
  countries: Countries,
  characters: Characters
}



// WEBPACK FOOTER //
// ./src/data/index.js